import React from "react";
import "./Button.scss";


const Button = ({ children, type, className, onClick, style, disable }) => {
    return (
        <button
            style={{ ...style }}
            onClick={onClick}
            className={`global-button ${className ? className : ""}`}
            type={type ? type : "button"}
            disabled={disable ? disable : null}
        >
            {children}
        </button>
    );
};

export default Button;
